export const initialAuthStore = {
  isAuthenticated: false,
  token: '',
  user: {
    blocked: false,
    confirmed: false,
    createdAt: '',
    email: '',
    id: '',
    provider: '',
    updatedAt: '',
    username: '',
  },
};

export const getAuthStore = () => {
  const savedAuthStore = localStorage.getItem('auth');
  if (savedAuthStore !== null) {
    return JSON.parse(savedAuthStore);
  }
  return initialAuthStore;
};

export const authStore = getAuthStore();

export interface IAuthStore {
  isAuthenticated: boolean;
  token: string;
  user: {
    blocked: boolean;
    confirmed: boolean;
    createdAt: string;
    email: string;
    id: string;
    provider: string;
    role: any;
    teams: any;
    updatedAt: string;
    username: string;
  };
}
